import { render, staticRenderFns } from "./temporarilyPricesheetadd.vue?vue&type=template&id=27bd997e&scoped=true"
import script from "./temporarilyPricesheetadd.vue?vue&type=script&lang=js"
export * from "./temporarilyPricesheetadd.vue?vue&type=script&lang=js"
import style0 from "./temporarilyPricesheetadd.vue?vue&type=style&index=0&id=27bd997e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bd997e",
  null
  
)

export default component.exports